import { Fragment } from 'react';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { CommonHexagonBadge } from '@/partials/common';

interface IntroProps {
  mode: 'create' | 'addSource';
}

const Intro: React.FC<IntroProps> = ({ mode }) => {
  // Überschrift abhängig vom Modus
  const headerText =
    mode === 'addSource'
      ? 'Neue Quelle zu einem bestehenden Angebot hinzufügen'
      : 'Neues Angebot intelligent erstellen';

  // Beschreibung abhängig vom Modus
  const descriptionText =
    mode === 'addSource'
      ? `Sie können bestehende Angebote oder Dokumente als neue Quelle zu diesem Angebot hinzufügen. 
         Diese Quellen werden analysiert, strukturiert und können als Trainingsdaten dienen, um zukünftige Angebote schneller, konsistenter und qualitativ hochwertiger zu erstellen. 
         Laden Sie dazu einfach vorhandene Angebotsdokumente hoch oder fügen Sie Texte ein – Buddy nutzt diese Informationen, um das System kontinuierlich zu verbessern.`
      : `Erstellen Sie ein neues Angebot auf Basis bereits vorhandener Angebote und Trainingsdaten. 
         Geben Sie dafür einfach einen Text ein oder sprechen Sie die Angebotsanforderungen ein. 
         Das Angebot wird automatisch anhand der gesprochenen oder eingegebenen Inhalte sowie der in der Datenbank vorhandenen Trainingsdaten erstellt. 
         
         Alternativ können Sie bestehende Angebotsdokumente hochladen. Diese werden analysiert und können ebenfalls als Trainingsdaten genutzt werden, um zukünftige Angebote noch präziser und effizienter zu generieren.`;

  return (
    <Fragment>
      <style>
        {`
          .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5.png')}');
          }
          .dark .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5-dark.png')}');
          }
        `}
      </style>

      <div className="card rounded-xl">
        <div className="flex items-center justify-between grow gap-2 p-5 [background-position:121%_41%] bg-no-repeat bg-[length:660px_310px] upgrade-bg">
          <div className="flex items-center gap-4">
            <CommonHexagonBadge
              stroke="stroke-success-clarity"
              fill="fill-success-light"
              size="size-[50px]"
              badge={<KeenIcon icon="information-4" className="text-xl text-success" />}
            />

            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-2.5 font-semibold">{headerText}</div>

              <div className="text-2sm text-gray-800">{descriptionText}</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export { Intro };
